import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import Navigator from "../Navigator/Navigator.js";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import API, { set } from "../../actions";
import Copyright from "./Copyright";
import styles from "./styles";
//import queryString from "query-string";
const useStyles = makeStyles(theme => styles);

const Login = props => {
    //const _queryString = queryString.parse(props.location.search);
    //console.log("_queryString",_queryString);
    const classes = useStyles();
    const dispatch = useDispatch();
    const therapist = useSelector(state => state.data.therapist);
    
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    //const [notLoaded, setNotLoaded] = useState(null);
    useEffect(() => {
        (async () => {               
            // if(_queryString.reepayURL){
            //     let r = await API.registerInvoice(_queryString.customerHandle);
            //     setNotLoaded(true);
            //     console.log(r);              
            // } 
            if (!localStorage.getItem("token")) return;
            const therapist = await API.getTherapist();
            if (therapist.trial > Date.now()) {
                if (window.localStorage.getItem("versionIndicator") === null)
                    window.localStorage.setItem("versionIndicator", "true");
                therapist.plan = window.localStorage.getItem("versionIndicator") ? "pro" : "light";
            }
            if (localStorage.getItem("token")) dispatch(set({ therapist: therapist }));
        })();
    }, [dispatch]);

    // if(notLoaded === true){
    //     console.log('notLoaded');
    //     window.location = _queryString.reepayURL;
    //     return <></>;
    // }
    return therapist ? (
        <MuiThemeProvider
            theme={theme =>
                createMuiTheme({
                    ...theme,
                    palette: {
                        ...theme.palette,
                        primary: {
                            main: therapist.colors !== null ? JSON.parse(therapist.colors)[1] : "#4d5ccc"
                        }
                    }
                })
            }>
            <Navigator />
        </MuiThemeProvider>
    ) : (
        <Grid container component="main" className={classes.root}>
            <CssBaseline />
            <Grid item xs={false} sm={4} md={7} className={classes.image} />
            <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
                <div className={classes.paper}>
                    <Avatar className={classes.avatar}>
                        <LockOutlinedIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Log ind
                    </Typography>
                    <form
                        className={classes.form}
                        onSubmit={event => {
                            event.preventDefault();
                            API.login(username, password).then(
                                therapist => window.location.reload(),
                                err => window.alert("Forkert login")
                            );
                        }}>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            label="Email"
                            name="email"
                            autoComplete="email"
                            autoFocus
                            onChange={event => setUsername(event.target.value)}
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label="Password"
                            type="password"
                            id="password"
                            autoComplete="current-password"
                            onChange={event => setPassword(event.target.value)}
                        />
                        <Grid container>
                            <Grid item xs></Grid>
                            <Grid item>
                                <Link
                                    to={{
                                        pathname: "/forgot_password"
                                    }}
                                    variant="body2">
                                    {"Har du glemt dit password? Nulstil det her"}
                                </Link>
                            </Grid>
                        </Grid>
                        <Button type="submit" fullWidth variant="contained" color="primary" className={classes.submit}>
                            Log ind
                        </Button>
                        <Grid container>
                            <Grid item xs></Grid>
                            <Grid item>
                                <Link
                                    to={{
                                        pathname: "/register"
                                    }}
                                    variant="body2">
                                    {"Har du ikke en konto? Registrer dig her"}
                                </Link>
                            </Grid>
                        </Grid>
                        <Box mt={5}>
                            <Copyright />
                        </Box>
                        <Box mt={20}>{""} </Box>
                        <Grid container>
                            <Grid item xs></Grid>
                            <Grid item>
                                <Link
                                    to={{
                                        pathname: "/admin"
                                    }}
                                    variant="body2">
                                    {"Administrator"}
                                </Link>
                            </Grid>
                        </Grid>
                    </form>
                </div>
            </Grid>
        </Grid>
    );
};

export default Login;
